import { useSyncExternalStore } from 'react'

const listeners = new Set<() => void>()
let snapshot = { pending: 0, revision: 0 }
const publish = (pending: number) => {
  snapshot = { pending, revision: snapshot.revision + 1 }
  for (const listener of listeners) listener()
}

/** Hold pricing until all cart writes have reconciled. */
export const beginCartWrite = (): (() => void) => {
  publish(snapshot.pending + 1)
  let finished = false
  return () => {
    if (finished) return
    finished = true
    publish(snapshot.pending - 1)
  }
}

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => { listeners.delete(listener) }
}

export const useCartWrites = () => useSyncExternalStore(subscribe, () => snapshot, () => snapshot)
